
import * as React from 'react';
import { UIComponentViewImpl } from '../../uicomponentview';
import { GridPaginationComponentProps, GridPaginationComponentState, GridPaginationComponentHandler } from './gridpaginationcomponent';
import { GridPaginationCSSStyle } from './gridpaginationcss';
import { ButtonComponent } from '../../button/buttoncomponent';
import { DisabledButtonCSSStyleImpl } from '../../../components/home/doityourself/buttoncss';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { PaginationCardComponent } from '../../pagination/paginationcard/paginationcardcomponent';
import { ConfirmRequestConfirmButtonCSSStyleImpl } from '../../../components/popup/confirmrequest/confirmrequestconfirmbuttoncss';
import "./gridpagination-style.css";

export class GridPaginationViewImpl<T> extends UIComponentViewImpl<T>
{
    bindHandlers()
    {
        this.onPageSelect = this.onPageSelect.bind(this);
        this.leftArrowClick = this.leftArrowClick.bind(this);
        this.rightArrowClick = this.rightArrowClick.bind(this);
    }

    draw(props: GridPaginationComponentProps<T>, state: GridPaginationComponentState, cssStyle: GridPaginationCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        console.log("------draw()pagination: isLeft: " + state.isLeftArrowEnabled);
        console.log("------draw()pagination: isright: " + state.isRightArrowEnabled);
       return (
        <div style={{display: "flex", flexFlow: "row wrap", justifyContent: "center", textAlign: "center", alignItems: "center"}}>
            {/* {state.isLeftArrowEnabled && <div style={cssStyle.getLeftArrowDivCSSStyle()} onClick={this.leftArrowClick}>
                <img style={cssStyle.getLeftArrowCSSStyle()} src={props.context.getResources().getImage("previous_black.svg")} height="30px"/>
            </div>}
                {
                   this.getListOfPages(state)
                }
            {state.isRightArrowEnabled && <div style={cssStyle.getRightArrowDivCSSStyle()} onClick={this.rightArrowClick}>
                <img style={cssStyle.getRightArrowCSSStyle()} src={props.context.getResources().getImage("next_black.svg")} height="30px"/>
            </div>} */}
        
        {<div id="grid-pagination-layout" style={cssStyle.getLeftArrowDivCSSStyle()}>
                <ButtonComponent onClick={state.isLeftArrowEnabled ? this.leftArrowClick : ()=>{}} style={state.isLeftArrowEnabled ? new ConfirmRequestConfirmButtonCSSStyleImpl(props.context): new DisabledButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.previous)}/>
            </div>}
                {
                   <PaginationCardComponent selectedPageNumber={state.currentPageNo} paginationIndex={state.currentPageNo} onSelectNext={()=>{}} context={this.getUIProps().context} key={state.currentPageNo}/>}
            {<div  id="grid-pagination-layout" style={cssStyle.getRightArrowDivCSSStyle()}>
            <ButtonComponent onClick={state.isRightArrowEnabled ? this.rightArrowClick: ()=>{}} style={state.isRightArrowEnabled ? new ConfirmRequestConfirmButtonCSSStyleImpl(props.context) : new DisabledButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.next)}/>
            </div>}
        </div>
       );
    }

    // getListOfPages(state: PaginationComponentState)
    // {
    //     let list = [];

    //     for(let i= state.startPageNo; i <= state.endPageNo; i++ )
    //     {
    //         // list.push(<div key={i} style={{paddingLeft: "10px", paddingRight: "10px"}} onClick={()=>this.onPageSelect(i)}>{i}</div>);
    //         list.push(<PaginationCardComponent selectedPageNumber={state.currentPageNo} paginationIndex={i} onSelectNext={this.onPageSelect} context={this.getUIProps().context} key={i}/>);
    //     }

    //     return list;
    // }

    private leftArrowClick()
    {
        (this.getUIComponentHandler() as GridPaginationComponentHandler).onLeftArrowSelect();
    }

    private rightArrowClick()
    {
        (this.getUIComponentHandler() as GridPaginationComponentHandler).onRightArrowSelect();
    }

    private onPageSelect(pageNumber: number)
    {
        (this.getUIComponentHandler() as GridPaginationComponentHandler).onPageSelect(pageNumber);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/grid/gridpagination/gridpaginationview.tsx